import { action, makeObservable, observable } from 'mobx';

class PaymentNotificationStore {
    constructor() {
        makeObservable(this)
    }

    @observable loadingItemStatus: boolean = false;
    @action setLoadingItemStatus(status: boolean) {
        this.loadingItemStatus = status;
    }

    // Payment Notification Datas
    @observable paymentNotificationDatas = {};

    @action addPaymentNotificationData(paymentNotificationId: number, paymentNotificationData: any) {
        this.paymentNotificationDatas[paymentNotificationId] = paymentNotificationData;
    }

    @action updatePaymentNotificationData(paymentNotificationId: number, paymentNotificationData: any) {
        this.paymentNotificationDatas[paymentNotificationId] = paymentNotificationData;
    }
    // Payment Notification Datas

    // Payment Notifications
    @observable paymentNotifications = {
        content: {},
        page: 1,
        pageCount: 1,
    }

    @action resetPaymentNotifications() {
        this.paymentNotifications = {
            content: {},
            page: 1,
            pageCount: 1,
        };
    }

    @action setPaymentNotifications(paymentNotifications: any) {
        this.paymentNotifications['content'] = paymentNotifications;
    }

    @action setPaginationData(page: number, pageCount: number) {
        this.paymentNotifications = {
            ...this.paymentNotifications,
            page,
            pageCount,
        };
    }

    @action addPaymentNotification(paymentNotificationId: number, paymentNotificationData: any) {
        this.paymentNotifications['content'][paymentNotificationId] = paymentNotificationData;
    }

    @action updatePaymentNotification(paymentNotificationId: number, paymentNotificationData: any) {
        if (this.paymentNotifications['content'][paymentNotificationId] !== undefined) {
            this.paymentNotifications['content'][paymentNotificationId] = paymentNotificationData;
        }

        if (this.paymentNotificationDatas[paymentNotificationId] !== undefined) {
            this.paymentNotificationDatas[paymentNotificationId] = paymentNotificationData;
        }
    }

    @action deletePaymentNotification(paymentNotificationId: number) {
        delete this.paymentNotifications['content'][paymentNotificationId];
    }
    // Payment Notifications

    // Search Payment Notifications
    @observable searchPaymentNotifications = {
        content: {},
        page: 1,
        pageCount: 1,
    };

    @action setSearchPaymentNotifications(searchPaymentNotifications: any) {
        this.searchPaymentNotifications = searchPaymentNotifications;
    }

    @action resetSearchPaymentNotifications() {
        this.searchPaymentNotifications = {
            content: {},
            page: 1,
            pageCount: 1,
        };
    }

    @action setSearchPaginationData(page: number, pageCount: number) {
        this.searchPaymentNotifications = {
            ...this.searchPaymentNotifications,
            page,
            pageCount,
        };
    }

    @action addSearchPaymentNotification(paymentNotificationId: number, paymentNotificationData: any) {
        this.searchPaymentNotifications.content[paymentNotificationId] = paymentNotificationData;
    }

    @action deleteSearchPaymentNotification(paymentNotificationId: number) {
        if (this.searchPaymentNotifications.content[paymentNotificationId] !== undefined) {
            delete this.searchPaymentNotifications.content[paymentNotificationId];
        }
    }

    @observable searchFilterText = "";
    @action setSearchFilterText(filterText: string) {
        this.searchFilterText = filterText;
    }
    // Search Payment Notifications
}

const store = new PaymentNotificationStore();

export default store;